<template>
	<div name="hrms31e-popup" id="hrms31e-popup" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">

		  <div class="modal-content">
		    <div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		      <h4 class="modal-title">{{ labels['HRPM31EP1']['240'] }}</h4>
		    </div>
		    <div class="modal-body detail detail-responsive">
					<div class="box-body">
						<div class="detail-block">
							<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['250'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-70" id="desc_codform" name="desc_codform">{{popupDetail.codempid}} - {{popupDetail.desc_codempid}}</div>
	              </div>
	            </div>
            </div>

            <div class="detail-block-float detail-block-left">
            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['260'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_department" name="v_department">{{popupDetail.v_department}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['280'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_position" name="v_position">{{popupDetail.v_position}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['300'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_jobcode" name="v_jobcode">{{popupDetail.v_jobcode}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['320'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_descempmt" name="v_descempmt">{{popupDetail.v_descempmt}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['340'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_typeemp" name="v_typeemp">{{popupDetail.v_typeemp}}</div>
	              </div>
	            </div>

            </div>

            <div class="detail-block-float detail-block-right">
            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['270'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_dteempmt" name="v_dteempmt">{{setDateOutput(popupDetail.v_dteempmt)}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['290'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="dtereemp" name="dtereemp">{{setDateOutput(popupDetail.dtereemp)}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['310'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_days" name="v_days">{{popupDetail.v_days}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['330'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="dte_show" name="dte_show">{{setDateOutput(popupDetail.dte_show)}}</div>
	              </div>
	            </div>

            	<div class="clearfix detail-row">
	              <div class="detail-left label-left">{{ labels['HRPM31EP1']['350'] }}</div>
	              <div class="detail-right">
	                  <div class="detail-text width-100" id="v_descpro" name="v_descpro">{{popupDetail.v_descpro}}</div>
	              </div>
	            </div>

            </div>

					</div>
				</div>
		    
		  </div>

		</div>
	</div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hrms31e-popup',
  data () {
    return {
      btn_close: 'Close'
    }
  },
  props: [ 'labels', 'popupDetail', 'receivedHrms31eDetailPopup' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>





// WEBPACK FOOTER //
// popup.vue?42286ed0